import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../Containers/PopupModalContainer";
import RectangleButton from "../Buttons/RectangleButton";
import { useMemo } from "react";
import { MARKIT_CONTACT_US } from "@markit/common.utils";
import { getAccountState } from "../../redux/slices/accountSlice";
import { useSelector } from "react-redux";

// A persistent modal that displays when a user's subscription is frozen.
const FrozenSubscriptionAccountModal = () => {
  const { accountData } = useSelector(getAccountState).account;

  const isFrozenSubscription = useMemo(
    () => accountData.customer.state === "FROZEN",
    [accountData.customer.state]
  );

  return isFrozenSubscription ? (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 14 }}>
          <Icon
            icon="ion:warning-outline"
            height={35}
            style={{ color: Colors.ORANGE1 }}
          />
          <span style={{ fontSize: 16, fontWeight: "500" }}>
            Your Subscription is Frozen
          </span>
        </div>
      }
      subHeaderComp={
        <div className="ColumnNormal" style={{ gap: 10 }}>
          <span style={{ fontSize: 14 }}>
            Your subscription is currently frozen and you cannot use any of our
            services until it is unfrozen.
          </span>
          <span style={{ fontSize: 14 }}>
            Please contact support to unfreeze your subscription and regain
            access to your account.
          </span>
        </div>
      }
      valueComp={
        <div className="ColumnCentering" style={{ gap: 14 }}>
          <RectangleButton
            buttonLabel={<span>Contact Support</span>}
            onPress={() => window.open(MARKIT_CONTACT_US)}
            altTextColor={Colors.WHITE}
            altColor={Colors.BLACK}
            altPaddingVert={14}
          />
        </div>
      }
      noExit
      closeModal={() => {}}
      modalContentWidth={PopupModalContainerWidth.SMALL}
    />
  ) : null;
};

export default FrozenSubscriptionAccountModal;
